import { useQuery } from '@tanstack/react-query';

type NotifyMeDataProps = {
    email: string;
    productId: string;
    source: string;
};

type NotifyMeResponse = {
    isFetchSuccessful: boolean;
};

export const useNotifyWhenBack = (notifyMeData: NotifyMeDataProps) => {
    return useQuery<NotifyMeResponse, Error>({
        queryKey: [],
        queryFn: async () => {
            const response = await fetch('/api/remindme', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(notifyMeData),
            });

            return { isFetchSuccessful: response.ok };
        },
        refetchOnMount: false,
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
